import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reorderQuestion } from "../../services/question";

const useReorderQuestion = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: reorderQuestion,
        onSuccess: (status) => {
            if(status === 200) {
                queryClient.invalidateQueries({queryKey: ["questionnaire_content"]});
            }
        }, onError: (error) => { } 
    });
}

export default useReorderQuestion;